import { transparentize } from 'polished';
import styled from 'styled-components';

import {
  breakpoints,
  convertPxToRem,
  radius,
  shadows
} from '@proprioo/salatim';

export const MapWrapper = styled.div`
  position: relative;
  height: ${convertPxToRem(350)};

  @media (min-width: ${breakpoints.xsmall}px) {
    height: ${convertPxToRem(500)};
  }
`;

export const MapWarning = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  transform: translate(-50%, -50%);
  padding: ${convertPxToRem(16)};
  background-color: ${transparentize(0.1, 'white')};
  border-radius: ${radius.normal};
  box-shadow: ${shadows.level2};
  width: 80%;
  pointer-events: none;

  @media (min-width: ${breakpoints.xsmall}px) {
    width: auto;
  }
`;

export const MapActions = styled.div`
  display: flex;
  margin: ${convertPxToRem(8)} 0;
`;

export const MapDelete = styled.div`
  margin-left: auto;
  align-self: flex-end;
`;
